/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { hatsAppApiConfiguration, hatsAppApiConfigurationParams } from './hats-app-api-configuration';

import { hatsAppConsumerService } from './services/hats-app-consumer.service';
import { hatsAppMonitorService } from './services/hats-app-monitor.service';
import { hatsAppTwilioService } from './services/hats-app-twilio.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    hatsAppConsumerService,
    hatsAppMonitorService,
    hatsAppTwilioService,
    hatsAppApiConfiguration
  ],
})
export class WhatsAppModule {
  static forRoot(params: hatsAppApiConfigurationParams): ModuleWithProviders<WhatsAppModule> {
    return {
      ngModule: WhatsAppModule,
      providers: [
        {
          provide: hatsAppApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: WhatsAppModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('WhatsAppModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
